import { formatEndpoint } from './configureHttp';



export const GetITMSSEUrl = (): string => formatEndpoint('/v1.0/io');